import { resetAuthGuardCache } from '@/lib/auth-guard';
import { logout } from '@/lib/auth-service';
import { useNavigate } from '@tanstack/react-router';

/**
 * Ends the session and sends the user to `/login`: Tahiti logout (always
 * clears the local token), then the auth guard's cached boot status is
 * dropped so guarded routes re-resolve. Shared by the rail's logout button and
 * the settings page, which logs everyone out after a Tahiti environment change.
 */
export function useLogout(): () => Promise<void> {
  const navigate = useNavigate();
  return async function handleLogout(): Promise<void> {
    try {
      await logout();
    } finally {
      resetAuthGuardCache();
      void navigate({ to: '/login' });
    }
  };
}
